import { useEffect, useState } from "react";
import { useFxStore } from "@/store/fxStore";

// 判定翻牌覆盖层：判定摸牌时全屏弹出，
// 牌从背面翻到正面，展示牌面花色与判定结果
export default function JudgmentOverlay() {
  const jfx = useFxStore((s) => s.judgment);
  const clear = useFxStore((s) => s.clearJudgment);
  const [flipped, setFlipped] = useState(false);

  // 翻牌时机：挂载后 500ms 翻到正面
  useEffect(() => {
    if (!jfx) {
      setFlipped(false);
      return;
    }
    setFlipped(false);
    const t = setTimeout(() => setFlipped(true), 500);
    return () => clearTimeout(t);
  }, [jfx]);

  if (!jfx) return null;

  const suitColor =
    jfx.suit === "红" ? "#e53935" : jfx.suit === "蓝" ? "#1e88e5" : jfx.suit === "黑" ? "#bbb" : "#999";
  const resultText = jfx.success
    ? `${jfx.responseKind ?? "判定"}成功`
    : "判定失败";
  const resultColor = jfx.success ? "#4caf50" : "#f44336";
  const desiredText = jfx.responseKind === "闪避" ? "红" : jfx.responseKind === "虚灵" ? "蓝" : "?";

  return (
    <div className="judgment-overlay" onClick={clear} role="dialog" aria-modal="true">
      <div className="judgment-overlay__inner" key={jfx.key}>
        <div className="judgment-overlay__title">
          {jfx.playerName} · 【{jfx.armorName}】判定
        </div>
        <div className="judgment-overlay__hint">
          需 <span style={{ color: suitColor === "#e53935" ? "#e53935" : suitColor === "#1e88e5" ? "#1e88e5" : "#bbb" }}>{desiredText}色</span>
        </div>

        {/* 3D 翻牌容器 */}
        <div className={`judg-card ${flipped ? "judg-card--flipped" : ""}`}>
          {/* 背面 */}
          <div className="judg-card__face judg-card__face--back">
            <div className="card__back-pattern">
              <span className="card__back-seal">命</span>
            </div>
          </div>
          {/* 正面 */}
          <div className="judg-card__face judg-card__face--front">
            <div className="judg-card__suit-row">
              <span className="judg-card__suit" style={{ color: suitColor }}>
                {jfx.suit ?? "·"}
              </span>
            </div>
            <div className="judg-card__name">{jfx.cardName}</div>
            <div className="judg-card__result" style={{ color: resultColor }}>
              {resultText}
            </div>
          </div>
        </div>

        <div className="judgment-overlay__result" style={{ color: resultColor }}>
          {resultText}
        </div>
      </div>
    </div>
  );
}
